import { userHotelDetails } from './../helpers/handleBrandAndHotelData';
import axiosInstance from './../helpers/interceptor';

export const selfAssessmentsDashboardList = async (userId) => {
  const { selectedHotel, selectedBrand} = userHotelDetails();
  const { data } = await axiosInstance.get(`${Env.API_URL}/customerAssessment/latestcount?selectedClientId=${selectedBrand}&hotelId=${selectedHotel}&isClientApp=true&userId=${userId}`);
  
  return data;
};
